class RecipientFormV2 extends HTMLElement {
  connectedCallback() {
    this.labelCheckbox = this.querySelector(".recipient-checkbox");
    this.labelCheckbox.addEventListener("click", () => {
      this.clearFields();
    });
  }

  clearFields() {
    this.nameEl = this.querySelector('[name="properties[Recipient name]"]');
    this.emailEl = this.querySelector('[name="properties[Recipient email]"]');
    this.messageEl = this.querySelector('[name="properties[Message]"]');
    this.SendOnEl = this.querySelector('[name="properties[Send on]"]');
    this.labelError = this.querySelector(".email-error-message");
    this.labelError && this.labelError.classList.add("hidden");

    this.nameEl && (this.nameEl.value = "");
    this.emailEl && (this.emailEl.value = "");
    this.messageEl && (this.messageEl.value = "");
    this.SendOnEl && (this.SendOnEl.value = "");
  }

  propertiesValues() {
    this.nameEl = this.querySelector('[name="properties[Recipient name]"]');
    this.emailEl = this.querySelector('[name="properties[Recipient email]"]');
    this.messageEl = this.querySelector('[name="properties[Message]"]');
    this.SendOnEl = this.querySelector('[name="properties[Send on]"]');

    this.nameEl && (this.nameValue = this.nameEl.value);
    this.emailEl && (this.emailValue = this.emailEl.value);
    this.messageEl && (this.messageValue = this.messageEl.value);
    this.SendOnEl && (this.SendOnValue = this.SendOnEl.value);

    return {
      "Recipient name": this.nameValue || "",
      "Recipient email": this.emailValue || "",
      Message: this.messageValue || "",
      "Send on": this.SendOnValue || "",
    };
  }

  validProperties() {
    this.checkbox = this.querySelector("#recipient-checkbox-v2");

    if (this.checkbox && !this.checkbox.checked) {
      return true;
    }
    const isValidEmail = this.validateEmail(this.emailValue);
    return isValidEmail;
  }

  validateEmail(email = "") {
    this.labelError = this.querySelector(".email-error-message");
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValid = regex.test(email);

    if (isValid) {
      this.labelError.classList.add("hidden");
    } else {
      this.labelError.classList.remove("hidden");
    }
    return isValid;
  }
}

customElements.define("recipient-form-v2", RecipientFormV2);
